import React from "react";
import styled from "@emotion/styled";
import theme from "../theme";

const SvgIconBase = styled.svg``;

export const CloseIcon = (props) => (
  <SvgIconBase {...props} viewBox="0 0 8 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.55673 6.00624L7.99986 1.14219L6.72168 0L1.27855 4.86405L1.27818 4.86371L0 6.00591L6.70771 12L7.98588 10.8578L2.55673 6.00624Z"
      fill="white"
    />
  </SvgIconBase>
);

export const SendIcon = (props) => (
  <SvgIconBase {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M13.1815 8.05261C13.2982 7.90186 13.2837 7.68585 13.147 7.55302C13.0103 7.4202 12.7968 7.41376 12.6523 7.53786L6.03868 13.2309L2.54609 11.8646C2.34259 11.7855 2.17634 11.6306 2.08277 11.4311C1.98874 11.2321 1.97421 11.0037 2.04234 10.7941C2.11002 10.5846 2.25492 10.409 2.44706 10.3047L16.9462 2.08651C17.0988 2.00333 17.2764 1.97897 17.4449 2.01849C17.6139 2.05756 17.7629 2.15775 17.8646 2.29977C17.9659 2.44225 18.0132 2.6169 17.9968 2.79154L16.725 16.206C16.6991 16.4849 16.5446 16.7354 16.3084 16.8811C16.0718 17.0273 15.7815 17.0516 15.5244 16.9473L11.2742 15.2822L8.60556 17.8123C8.47337 17.9368 8.29849 18.0044 8.11771 17.9998C7.93692 17.9952 7.76522 17.9189 7.63986 17.7879C7.51403 17.6565 7.44454 17.4804 7.4459 17.2975V15.3106L13.182 8.05261H13.1815Z"
      fill={theme.colors.primary}
    />
  </SvgIconBase>
);

export const CloseCTA = (props) => (
  <SvgIconBase {...props} viewBox="0 0 6 6" fill="none">
    <path
      d="M0.87868 2.18198L1.93934 3.24264L0.87868 4.3033C0.738028 4.44395 0.65901 4.63472 0.65901 4.83363C0.65901 5.03254 0.738027 5.22331 0.87868 5.36396C1.01933 5.50461 1.2101 5.58363 1.40901 5.58363C1.60792 5.58363 1.79869 5.50461 1.93934 5.36396L3 4.3033L4.06066 5.36396C4.20131 5.50461 4.39208 5.58363 4.59099 5.58363C4.7899 5.58363 4.98067 5.50461 5.12132 5.36396C5.26197 5.22331 5.34099 5.03254 5.34099 4.83363C5.34099 4.63472 5.26197 4.44395 5.12132 4.3033L4.06066 3.24264L5.12132 2.18198C5.26197 2.04133 5.34099 1.85056 5.34099 1.65165C5.34099 1.45274 5.26197 1.26197 5.12132 1.12132C4.98067 0.980668 4.7899 0.90165 4.59099 0.90165C4.39208 0.90165 4.20131 0.980668 4.06066 1.12132L3 2.18198L1.93934 1.12132C1.79869 0.980668 1.60792 0.90165 1.40901 0.90165C1.2101 0.90165 1.01933 0.980668 0.87868 1.12132C0.738027 1.26197 0.65901 1.45274 0.659009 1.65165C0.65901 1.85056 0.738028 2.04133 0.87868 2.18198Z"
      fill="white"
    />
  </SvgIconBase>
);
